
var Model = require("../types/Model.js");

var Promise = require("promise");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var Image = ReactNative.Image;
var Platform = ReactNative.Platform;
var global = require("global");
var par = require("par");
var exif = require("image-uri-exif-orientation");

module.exports = Model({
	name: "managedprofilepicture",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_image: null,
	_who: null,
	_group: "",
	_orientation: null,

	reset: reset,
});

function init() {
	this.reset();
}

function listeners() {
	return {
		"managedaccount:updated": handle_managed_account_update,
	};
}

function triggers() {
	return {
		"start": start_updating,
		"crop": crop_and_upload,
		"cancel": cancel_updating
	};
}

function reset() {
	this._image = null;
	this._orientation = null;

	this.push({
		image: null,
		width: 0,
		height: 0,
		orientation: null,
	});
}

function handle_managed_account_update(managedaccount) {
	var data = managedaccount.data;
	var open = managedaccount.open;

	if(!open){
		if(this._who) this.reset();
		return;
	}

	var who = data._id;
	this._who = who;
	const group = managedaccount.group;
	this._group = group;
}

function start_updating(data) {
	var image = data.image;
	this._image = image;

	this.emit("usermetrics:trigger:track", "begin updating managed user's profile picture", {
		who: this._who,
	});

	this.emit("save:trigger:start");
	if(image.isCordova || image.isNative)
		return loadImageSize(image)
			.then(handle_got_size.bind(this))
			.catch(handle_error.bind(this))
			.then(finish_save.bind(this));

	return loadImageSize(image)
		.then(handle_got_size.bind(this))
		.then(par(getImageOrientation, image))
		.then(handle_got_orientation.bind(this))
		.catch(handle_error.bind(this))
		.then(finish_save.bind(this));
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function loadImageSize(image) {
	if(!isWeb()) return getSized(image);
	return loadFileWeb(image).then(getSized);
}

function loadFileWeb(image) {
	return new Promise(function (resolve, reject) {
		if ( image.isCordova) {
			return resolve({
				uri: image.url
			});
		}
		var FileReader = global.FileReader;

		var reader = new FileReader();
		reader.onload = function(){
			var result = reader.result;
			resolve({
				uri: result
			});
		}.bind(this);
		reader.readAsDataURL(image);
		reader.onerror = reject;
	});
}

function getSized(image) {
	var uri = image.uri;

	return new Promise(function(resolve, reject){
		Image.getSize(uri, function(width, height){
			resolve({
				image: image,
				width: width,
				height: height
			});
		}, reject);
	});
}

function isWeb() {
	return Platform.OS === "web";
}

function handle_got_size(size) {
	this.extend(size);
	this.dispatch("started");
}

function handle_got_orientation(orientation) {
	this._orientation = orientation;
	this.extend(orientation);
}

function handle_error(e) {
	this.emit("save:trigger:finish");
	console.error(e);
}

function crop_and_upload(data) {
	var who = this._who;
	var group = this._group;
	if(!who) return;
	var crop = data.crop;
	var image = isWeb() ? this._image : this.data.image;

	if(data.image)
		image = data.image;

	var orientation = 0;
	if(this._orientation)
		orientation = this._orientation.orientation;
	var rotateMap = {
		"-2": 0,
		"-1": 0,
		"0": 0,
		"1": 0,
		"2": 0,
		"3": 180,
		"4": 0,
		"5": 0,
		"6": 90,
		"7": 0,
		"8": 270
	};

	this.emit("save:trigger:start");

	var rotation = image.isNative ? image.originalRotation : rotateMap[orientation];

	this.api.manage.picture(image, who, {
		crop: crop,
		rotate: rotation || 0
	}, group)
		.then(handle_uploaded.bind(this))
		.catch(handle_error.bind(this));

	this.emit("usermetrics:trigger:track", "update managed user's profile picture", {
		who,
	});
}

function handle_uploaded() {
	this.emit("save:trigger:finish");
	this.dispatch("success");
	this.reset();
}

function cancel_updating() {
	this.emit("usermetrics:trigger:track", "cancel updating managed user's profile picture", {
		who: this._who,
	});
	this.dispatch("cancelled");
	this.reset();
}

function getImageOrientation(image) {
	if(!isWeb()) return getOrientation(image);
	return loadFileWeb(image).then(getOrientation);
}

function getOrientation(image) {
	return exif(image.uri).then(function (orientation) {
		return {
			orientation: orientation
		};
	});
}
